import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Format from './../Format';
import axios from 'axios';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import User from '../../Models/User';
import Message from '../Message';
//import axios from 'axios';
import datas from "../../Assets/data.json";
import env from 'react-dotenv';
import { Crypter } from '../../Functions/Security/Crypter';
import { useAlert, Spin, Input, Select, Button } from '../ui';


export interface ConfirmationDialogRawProps {
    classes: Record<'paper', string>;
    id: string;
    keepMounted: boolean;
    value: string;
    open: boolean;
    onClose: (value?: string) => void;
}

export interface Ticket {
    CodeT: string,
    CodeAbonne: string,
    CodeU: String,
    CodeS: String,
    CodeFiliale: String
}

const GenerateForm = (props: { codePromo?: string, handleFunction: any }) => {


    // USER TOKEN
    const authHeader = useAuthHeader()
    // USER SESSION
    const auth = useAuthUser()
    const user: User = JSON.parse(JSON.stringify(auth() || {}))
    const alert = useAlert();

    const { register, handleSubmit, setValue, reset } = useForm()
    const [fichier, setFicher] = useState<File>()
    const [isOk, setIsOk] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)

    const [firstLetter, setfirstLetter] = useState('');
    const [firstLetters, setfirstLetters] = useState([])

    const [serviceVal, setServiceVal] = React.useState('');

    const [services, setServices] = React.useState([]);

    useEffect(() => {
        loadEntiteServices()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    function loadEntiteServices() {
        const codeAbonne = user.CodeAbonne
        setLoading(true)
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.GetFilialeServices + Crypter.encrypt(codeAbonne),
            headers: {
                'Accept': 'text/plain',
                'Authorization': authHeader(),
            }
        };

        axios.request(config)
            .then((response: any) => {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value
                if (res.StatutCode == 200) {
                    setLoading(false)

                    var ss: any = []

                    res.Result[1].map((s: any) => {
                        if (s.CodeFiliale == user.CodeFiliale) {
                            ss.push(s)
                        }
                    })
                    setServices(ss)

                }
                else {
                    setLoading(false)
                    setServices([])
                    alert.warning(res.Message)
                }
            })
            .catch((error: any) => {
                alert.error('Error', error)
                setLoading(false)
                console.log(error);
            });
    }

    useEffect(() => {
        setValue("CodePromo", props.codePromo)
    })

    const loadfirstLetter = async () => {
        setLoading(true)

        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: datas.BASE_URL + datas.API_LINKs.Qm.CaissiereByAG,
            headers: {}
        };
        axios.request(config)
            .then((response) => {
                setLoading(false)
                if (response.data.statutCode == 200) {
                    //alert(JSON.stringify(response.data))
                    setfirstLetters(JSON.parse(response.data.result).Table)
                } else {
                    alert.warning(response.data.message)
                }
            })
            .catch((error) => {
                setLoading(false)
                alert.error(JSON.stringify(error))
            });

    }
    const onSubmit = async (data: any) => {

        if (serviceVal.length != 0) {


            if (data.number.toString().length <= data.taille) {
                setLoading(true)

                var tickets: Ticket[] = []

                for (let index = 0; index <= data.number; index++) {
                    var prefix = ""
                    for (let j = 0; j < data.taille - index.toString().length; j++) {
                        prefix += "0";
                    }
                    tickets.push(
                        {
                            "CodeT": data.firstLetter + prefix + index,
                            "CodeAbonne": user.CodeAbonne,
                            "CodeU": user.CodeU,
                            "CodeS": serviceVal,
                            "CodeFiliale": user.CodeFiliale
                        }
                    )
                }


                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: env.API_BASE_URL + datas.API_LINKs.GenerateTickets,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': authHeader(),
                    },
                    data: Crypter.encrypt(JSON.stringify(tickets))
                };

                axios.request(config)
                    .then((response) => {
                        setLoading(false)
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value
                        if (res.StatutCode == 200) {
                            alert.success(res.Message)
                            reset()
                            props.handleFunction()
                        } else {
                            alert.warning(res.Message)
                        }

                    })
                    .catch((error) => {
                        setLoading(false)
                        alert.error(error.message)
                    });
            }
            else {
                alert.warning("Taille du ticket et nombre de tickets à générer non corespondant")
            }
        }
        else {
            alert.warning("Veillez sélectionner le service dans lequel vous voulez générer les tickets!")
        }


    }
    const handleChangeService = (value: string) => {
        setServiceVal(value);
    };

    return (
        <>
            <Spin spinning={loading}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='round0'>{/*className='round0'*/}
                        <div className='ressource'>
                            <div className="flex gap-3">
                                <Input
                                    onKeyUp={() => setIsOk(false)}
                                    {...register("firstLetter")}
                                    className='input'
                                    required
                                    onChange={(e: any) => { e.target.value = e.target.value[e.target.value.length - 1] }}
                                    type='text'
                                    label={'Premier Caractère'}
                                    placeholder={"Exemple : A, B, C, ..."} />

                                <Input
                                    onKeyUp={() => setIsOk(false)}
                                    {...register("taille")}
                                    className='input'
                                    required
                                    type='number'
                                    label={'Taille du ticket'}
                                    placeholder={"Taille du ticket"} />

                                <Input
                                    onKeyUp={() => setIsOk(false)}
                                    {...register("number")}
                                    className='input'
                                    required
                                    type='number'
                                    label={'Nombre de ticket'}
                                    placeholder={"Nombre de ticket à générer"} />
                            </div>
                            <div className="w-full mt-3">
                                <Select
                                    label="Service"
                                    value={serviceVal}
                                    onChange={handleChangeService}
                                    options={services.map((data: any) => ({
                                        value: data.CodeS,
                                        label: data.CodeS + ' - ' + data.Libelle
                                    }))}
                                />
                            </div>
                            <br />
                            <Button className='w-full' variant='secondary' type='submit'>Générer</Button>
                        </div>
                    </div>

                </form>
            </Spin>
        </>
    );
};

export default GenerateForm;
